export default __webpack_public_path__ + "static/media/trophy.ef428066.gif";